//react
import { useState } from "react";

//form
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

//components
import Input from "../Input";
import { Container } from "./styles";
import Button from "../Button";
import { useHabUnits } from "../../Providers/HabUnit";
import { IProductHU, IReserve, IServiceHU } from "../../Interfaces";
import { userID } from "../../Services/api";

interface IHUInProp {
  id: number;
  type: string;
  title: string;
  price: number;
  description: string;
  idAdm: number;
  products: IProductHU[];
  services: IServiceHU[];
  reserves: IReserve[];
  state: "available" | "occupied" | "maintenance" | "reserved";
}

interface IHUFromProps {
  HU?: IHUInProp;
  closeModal: () => void;
}

export const HUForm = ({
  HU = {
    id: 0,
    type: "suite",
    title: "",
    price: 0,
    description: "",
    idAdm: 0,
    products: [],
    services: [],
    reserves: [],
    state: "available" as "available",
  },
  closeModal,
}: IHUFromProps) => {
  const situation = !!HU.id;
  const [buttonName] = useState<string>(situation ? "Editar" : "Cadastrar");
  const { type, title, price, description, state } = HU;
  const { createHU, editHU } = useHabUnits();

  const formSchema = yup.object().shape({
    type: yup.string().required("Tipo obrigatório"),
    state: yup.string().required("Estádo obrigatório"),
    title: yup
      .string()
      .required("Nome obrigatório")
      .max(10, "Máximo 10 caractéres"),
    price: yup
      .string()
      .required("Preço obrigatŕio")
      .max(10, "Máximo 10 caractéres"),
    description: yup.string().required("Descrição obrigatória"),
  });

  interface IdefaultValues {
    type: string;
    state: string;
    title: string;
    price: number | string;
    description: string;
  }

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<IdefaultValues>({
    defaultValues: {
      type: type,
      state: state,
      title: title,
      price: !!price ? price : "",
      description: description,
    },
    resolver: yupResolver(formSchema),
  });

  interface IHUData {
    type: string;
    state: string;
    title: string;
    price: string;
    description: string;
  }

  const onSubmit = (data: IHUData): void => {
    const { type, title, price, description, state } = data;
    const { idAdm, products, services, reserves } = HU;
    const submitData = {
      type: type,
      title: title,
      price: Number(price),
      description: description,
      idAdm: idAdm,
      products: products,
      services: services,
      reserves: reserves,
      state: state as "available" | "occupied" | "maintenance" | "reserved",
    };
    if (situation) {
      const { id } = HU;
      editHU({ id: id, ...submitData, dailyCharges: [], guests: [] });
    } else {
      createHU({ ...submitData, idAdm: userID, dailyCharges: [] });
    }
    closeModal();
  };

  return (
    <Container>
      <form onSubmit={handleSubmit(onSubmit)}>
        <select {...register("type")}>
          <option value="simpleRoom">simples</option>
          <option value="suite">suíte</option>
          <option value="executive">executivo</option>
          <option value="deluxe">deluxe</option>
          <option value="others">outros</option>
        </select>
        {!!errors.type && <p className="error">{errors.type.message}</p>}
        <select {...register("state")}>
          <option value="available">disponível</option>
          {/* <option value="occupied">ocupado</option> */}
          <option value="maintenance">em manutenção</option>
          <option value="reserved">reservado</option>
        </select>
        {!!errors.state && <p className="error">{errors.state.message}</p>}
        <Input
          className="titleInput"
          label="Título"
          name="title"
          register={register}
          placeholder="Título"
        />
        {!!errors.title && <p className="error">{errors.title.message}</p>}
        <Input
          className="priceInput"
          label="Preço"
          name="price"
          register={register}
          placeholder="Preço"
        />
        {!!errors.price && <p className="error">{errors.price.message}</p>}
        <Input
          className="descriptionInput"
          label="Descrição"
          name="description"
          register={register}
          placeholder="Descrição"
        />
        {!!errors.description && (
          <p className="error">{errors.description.message}</p>
        )}
        <Button className="submit" type="submit">
          {buttonName}
        </Button>
      </form>
    </Container>
  );
};
